import { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { FaTrash, FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";
import { getUserRole } from "../roleCrypto";

const API = process.env.REACT_APP_API_URL;
const userRole = getUserRole();
console.log(API);

function Users() {
  useEffect(() => {
    document.title = "Users | Admin Panel";
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const [users, setUsers] = useState([]);

  // modal
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  // form
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [editId, setEditId] = useState(null);

  // search
  const [search, setSearch] = useState("");

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  // ✅ FETCH USERS
  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(`${API}/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setUsers(res.data);
    } catch (err) {
      if (err.response?.status === 401) {
        toast.error("Token expired");
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
    }
  };

  // ✅ DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this user?")) return;

    try {
      const token = localStorage.getItem("token");

      await axios.delete(`${API}/users/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success("User deleted");
      fetchUsers();
    } catch (err) {
      toast.error("Delete failed");
    }
  };

  // ✅ EDIT OPEN
  const handleEdit = (user) => {
    setName(user.name);
    setEmail(user.email);
    setPhone(user.phone || "");
    setEditId(user.id);
    setIsEdit(true);
    setShowModal(true);
  };

  // ✅ ADD OPEN
  const handleAdd = () => {
    setName("");
    setEmail("");
    setPhone("");
    setIsEdit(false);
    setEditId(null);
    setShowModal(true);
  };

  // ✅ SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const payload = {
        name,
        email,
        phone,
      };

      if (isEdit) {
        await axios.put(`${API}/users/${editId}`, payload, config);
        toast.success("User updated");
      } else {
        await axios.post(`${API}/users`, payload, config);
        toast.success("User created");
      }

      setShowModal(false);
      fetchUsers();
    } catch (err) {
      console.log(err);

      if (err.response) {
        if (err.response?.status === 401) {
            toast.error("Unauthorized token");
            localStorage.removeItem("token");
            window.location.href = "/login";
          }
        if (err.response.data.message) {
          toast.error(err.response.data.message);
        } else if (err.response.data.errors) {
          const errors = err.response.data.errors;

          Object.values(errors).forEach((messages) => {
            toast.error(messages[0]);
          });
        } else {
          toast.error("Validation failed ❌");
        }
      } else {
        toast.error("Server not responding ❌");
      }
    }
  };

  // ✅ FILTER
  const filteredUsers = users.filter((u) =>
    u.name.toLowerCase().includes(search.toLowerCase())
  );

  // ✅ PAGINATION
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar isOpen={isOpen} toggleSidebar={() => setIsOpen(!isOpen)} />

      <div className="flex-1 flex flex-col">
        <Header toggleSidebar={() => setIsOpen(!isOpen)} />

        <main className="p-6">
          {/* TOP BAR */}
         <div className="flex flex-col md:flex-row justify-between gap-4 mb-6">
            <h2 className="text-2xl font-bold">Users</h2>

            <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search users..."
                className="border px-4 py-2 rounded-lg w-full md:w-64"
              />

              <button
                onClick={handleAdd}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg"
              >
                + Add
              </button>
            </div>
          </div>

          {/* USERS CARDS */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {currentUsers.map((user) => (
              <div
                key={user.id}
                className="bg-white p-5 rounded-xl shadow hover:shadow-xl hover:-translate-y-1 transition duration-300"
              >
                <h3 className="font-bold text-lg">{user.name}</h3>

                <p className="text-gray-500">{user.email}</p>

                {/* ✅ PHONE */}
                <p className="text-gray-500">
                  {user.phone ? `📞 ${user.phone}` : "No phone"}
                </p>

                {/* ACTIONS */}
                <div className="flex justify-between items-center mt-4">
                  {userRole !== "subadmin" && (
                  <button
                    onClick={() => handleEdit(user)}
                    className="flex items-center gap-2 text-blue-600"
                  >
                    <FaEdit className="text-sm" />
                    Edit
                  </button>
                  )}
                 {userRole !== "subadmin" && (
                  <button
                    onClick={() => handleDelete(user.id)}
                    className="flex items-center gap-2 text-red-600"
                  >
                    <FaTrash className="text-sm" />
                    Delete
                  </button>
                 )}
                </div>
              </div>
            ))}
          </div>

          {/* PAGINATION */}
          {totalPages > 1 && (
            <div className="flex justify-center mt-6 gap-2">
              <button
                onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                className="px-3 py-1 bg-white border"
              >
                Prev
              </button>

              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentPage(i + 1)}
                  className={`px-3 py-1 border ${
                    currentPage === i + 1
                      ? "bg-blue-600 text-white"
                      : "bg-white"
                  }`}
                >
                  {i + 1}
                </button>
              ))}

              <button
                onClick={() =>
                  setCurrentPage((p) => Math.min(p + 1, totalPages))
                }
                className="px-3 py-1 bg-white border"
              >
                Next
              </button>
            </div>
          )}
        </main>
      </div>

      {/* MODAL */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center">
          <div className="bg-white w-full max-w-md p-6 rounded-xl">
            <h2 className="text-xl font-bold mb-4">
              {isEdit ? "Edit User" : "Add User"}
            </h2>

            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Name"
                className="w-full border p-2 rounded"
                required
              />

              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                className="w-full border p-2 rounded"
                required
              />

              {/* ✅ PHONE INPUT */}
              <input
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Phone Number"
                className="w-full border p-2 rounded"
              />

              <div className="flex gap-2">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="w-full bg-gray-300 p-2 rounded"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="w-full bg-blue-600 text-white p-2 rounded"
                >
                  {isEdit ? "Update" : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Users;